import style from './WorkPlace.module.css'
import { MapContainer } from '../../Components/Map/MapContainer'
import { MapList } from '../../Components/MapList/MapList'
import { useEffect } from 'react'
import { getStoresThunk } from '../../Redux/Slices/Stores/thunks';
import { getVendorsThunk } from '../../Redux/Slices/Vendors/thunks';
import { getCableTagsThunk } from '../../Redux/Slices/Cables/thunks';
import { useDispatch } from 'react-redux';
import Tools from '../../Components/Tools/Tools';

export const WorkPlace = () => {
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(getStoresThunk())
        dispatch(getVendorsThunk())
        dispatch(getCableTagsThunk())
    }, [dispatch])

    return (
        <div className={style.workPlace}>
            <div className={style.container} >
                <Tools />
                <MapContainer />
            </div>
            <MapList />
        </div>
    )
}